export default __webpack_public_path__ + "media/images/users-and-groups-1235619e7a1a0c14ee79bd356514ed67.png";